import { createSelector } from 'reselect';
import format from 'date-fns/format';
import { getDateFormatOptions, getDateFormat, DATE_FORMATS } from '@gameday/utils/languageHelpers';

const scoreDisplayLogic = {
    runs: 'greater',
    hits: 'greater',
    hr: 'greater',
    totalBases: 'greater',
    stolenBases: 'greater',
    wins: 'greater',
    avg: 'greater',
    errors: 'lower',
    era: 'lower',
    leftOnBase: ''
};

const formatDate = (language, date) => {
    const options = getDateFormatOptions(language);
    const dateFormat = getDateFormat(language, DATE_FORMATS.STANDARD);

    return format(new Date(`${date}T12:01:00Z`), dateFormat, options) || '';
};

const getGame = (state) => {
    const { language = 'en' } = state.config;
    const { homeStats, awayStats } = state?.teamStatsGame || {};
    const { teamComparisonGameType } = state?.teamStatsSeasonAllTime || {};

    return {
        tableRows: [{ ...awayStats, language, scoreDisplayLogic }, { ...homeStats, language, scoreDisplayLogic }],
        teamComparisonGameType
    };
};

const getSeason = (state) => {
    const { config, gumbo, teamStatsSeasonAllTime } = state;
    const { language = 'en' } = config;
    const { gameData: { teams, game: { season, type }, datetime: { originalDate } } } = gumbo;
    const { away, home, teamComparisonGameType } = teamStatsSeasonAllTime;
    const homeId = teams?.home?.id;
    const awayId = teams?.away?.id;
    const homename = teams?.home?.teamName;
    const awayname = teams?.away?.teamName;

    const awayStats = {
        team: awayId,
        sportId: teams?.away?.sport?.id,
        name: awayname,
        wins: away?.season?.wins,
        runs: away?.season?.runs,
        hr: away?.season?.hr,
        avg: away?.season?.avg,
        era: away?.season?.era
    };

    const homeStats = {
        team: homeId,
        sportId: teams?.home?.sport?.id,
        name: homename,
        wins: home?.season?.wins,
        runs: home?.season?.runs,
        hr: home?.season?.hr,
        avg: home?.season?.avg,
        era: home?.season?.era
    };

    return {
        tableRows: [{
            ...awayStats,
            otherteam: homeStats,
            language,
            scoreDisplayLogic
        }, {
            ...homeStats,
            otherteam: awayStats,
            language,
            scoreDisplayLogic
        }],
        gameDate: formatDate(language, originalDate),
        season,
        teamComparisonGameType,
        gameType: type
    };
};

const getAllTime = (state) => {
    const { config, gumbo, teamStatsSeasonAllTime } = state;
    const { language = 'en' } = config;
    const { gameData: { teams, game: { season, type }, datetime: { originalDate } } } = gumbo;
    const { away, home, teamComparisonGameType } = teamStatsSeasonAllTime;
    const homeId = teams?.home?.id;
    const awayId = teams?.away?.id;
    const homename = teams?.home?.teamName;
    const awayname = teams?.away?.teamName;

    const awayStats = {
        team: awayId,
        sportId: teams?.away?.sport?.id,
        name: awayname,
        wins: away?.alltime.wins,
        runs: away?.alltime.runs,
        hr: away?.alltime?.hr,
        avg: away?.alltime.avg,
        era: away?.alltime.era
    };

    const homeStats = {
        team: homeId,
        sportId: teams?.away?.sport?.id,
        name: homename,
        wins: home?.alltime.wins,
        runs: home?.alltime.runs,
        hr: home?.alltime?.hr,
        avg: home?.alltime.avg,
        era: home?.alltime.era
    };

    return {
        tableRows: [{
            ...awayStats,
            otherteam: homeStats,
            language,
            scoreDisplayLogic
        }, {
            ...homeStats,
            otherteam: awayStats,
            language,
            scoreDisplayLogic
        }],
        gameDate: formatDate(language, originalDate),
        season,
        teamComparisonGameType,
        gameType: type
    };
};

export const getGameStats = createSelector(
    [getGame],
    (info) => {
        return info;
    }
);

export const getSeasonStats = createSelector(
    [getSeason],
    (info) => {
        return info;
    }
);

export const getAllTimeStats = createSelector(
    [getAllTime],
    (info) => {
        return info;
    }
);
